module.exports = __webpack_public_path__ + "img/self.7a29af5e.svg";